import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    openInBrowser: string;
    menuTitle: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label to open workspace in a browser */
            openInBrowser: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuForIntegrations.openInBrowser?c=1e8nshczpr2it", defaultMessage: "Open in browser" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu group title for workspace actions */
            menuTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuForIntegrations.menuTitle?c=fvis4ig6qtg3", defaultMessage: "Workspace" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
